import { Property } from 'posthog-js'

const REPLACEMENT_VALUE = 'MASKED_VALUE'

const TO_SANITIZE_WITH_URL = [
  '$current_url',
  '$session_entry_url',
  '$initial_current_url',
  'url',
  'previous_url',
]
const TO_SANITIZE_WITH_QUERY_STRING = ['search', 'previous_search']

const TO_SANITIZE_DELETE = ['$initial_person_info']

const SENSITIVE_QUERY_PARAMS = ['code', 'state', 'session_state']

const sanitizeUrl = (url: string): string => {
  const parsedUrl = new URL(url)
  for (const param of SENSITIVE_QUERY_PARAMS) {
    if (!parsedUrl.searchParams.has(param)) {
      continue
    }
    parsedUrl.searchParams.set(param, REPLACEMENT_VALUE)
  }
  return parsedUrl.toString()
}

const sanitizeQueryString = (searchParams: string): string => {
  const parsedSearchParams = new URLSearchParams(searchParams)
  for (const param of SENSITIVE_QUERY_PARAMS) {
    if (!parsedSearchParams.has(param)) {
      continue
    }

    parsedSearchParams.set(param, REPLACEMENT_VALUE)
  }
  return parsedSearchParams.toString()
}

export function sanitize(properties: Record<string, Property>) {
  for (const key in properties) {
    const value = properties[key]
    if (TO_SANITIZE_WITH_URL.includes(key)) {
      properties[key] = sanitizeUrl(value)
    } else if (TO_SANITIZE_WITH_QUERY_STRING.includes(key)) {
      properties[key] = `?${sanitizeQueryString(value)}`
    } else if (TO_SANITIZE_DELETE.includes(key)) {
      delete properties[key]
    }
  }
}
